/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/MessageArea" />
import * as React from 'react';
import { Link } from 'VSSUI/Link';
import { VssComponent } from 'VSS/Platform/Layout';

export interface IMessageAreaComponentProps {
    text: string,
}

export class MessageArea extends VssComponent<IMessageAreaComponentProps, {}> {
    
    private Linkyfy(str: string) {
        const elements = [];

        let text = str;
        const mdLinkRegex = /\[(.*?)\]\((.*?)\)/;
        
        let link = text.match(mdLinkRegex);
        while (link) {
            // The ! is to suppress "Object is possibly null" typescript error
            elements.push(text.slice(0, link!.index));
            elements.push(<Link key={elements.length} href={link![2]}>{link![1]}</Link>)
            
            text = text.slice((link!.index!) + link![0].length);
            link = text.match(mdLinkRegex);
        };

        if (text) {
            elements.push(text);
        }

        return elements;
    }

    public render(): JSX.Element {
        return (
            <div>{ this.Linkyfy(this.props.text) }</div>
        );
    } 
}
